// GENERATE BY ../scripts/generate.js
// DON NOT EDIT IT MANUALLY
/* eslint-disable */
import React, { forwardRef, MutableRefObject } from 'react';
import { IconProps } from '../type';
import classNames from 'classnames';
import useConfig from '../../_util/useConfig';
import useSizeProps from '../useSizeProps';

const ChevronLeftIcon = (props: IconProps, ref: MutableRefObject<SVGSVGElement>) => {
  const { classPrefix } = useConfig();
  const { size, className: customClassName, style: customStyle, ...restProps } = props;
  const { className: sizeClassName, style: sizeStyle } = useSizeProps(size);
  const className = classNames(classPrefix + '-icon',classPrefix+'-icon-chevron-left', sizeClassName, customClassName);
  const style = { ...customStyle, ...sizeStyle }

  return (
    <svg ref={ref} className={className} style={style} {...restProps} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path  fillOpacity=".9" fillRule="evenodd" d="M610.5408 226.56L669.3696 285.39136 442.78784 511.97568 669.3696 738.56 610.5408 797.3888 325.12512 511.97568 610.5408 226.56Z" clipRule="evenodd"/></svg>
  )
};

ChevronLeftIcon.displayName = 'ChevronLeftIcon';

export default forwardRef<SVGSVGElement, IconProps>(ChevronLeftIcon);
